module.exports = __webpack_public_path__ + "img/cws.830bd5b.png";